import { Chip, Tooltip } from "@mui/material";
import { riskLevel, scheduleStatus } from "../constants/labels";
import { ossChipSx } from "./common/ossChipStyles";

export const OssStatusChip = ({ type = "schedule", value, size = "small" }) => {
  const source = type === "risk" ? riskLevel : scheduleStatus;
  const meta = source[value] || { label: value || "-", tone: "#64748b", bg: "#f8fafc" };
  const chip = (
    <Chip
      size={size}
      label={meta.label}
      variant="outlined"
      sx={ossChipSx({ tone: meta.tone, bg: meta.bg, size })}
    />
  );
  return type === "risk" ? <Tooltip describeChild title="착수 필요일 기준 위험도입니다. 주문 진행 단계나 실제 납기 지연 여부와는 별개입니다.">{chip}</Tooltip> : chip;
};
